import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '@/hooks/stores/useAuth';
import Cookies from 'js-cookie';

const AuthInitializer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, userRole } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize authentication state from cookies
    const accessToken = Cookies.get('accessToken');
    const role = Cookies.get('userRole');
    const userFlow = Cookies.get('userFlow');
    const paymentStatus = Cookies.get('paymentStatus');
    
    // Small delay to ensure cookies are read and state is updated
    setTimeout(() => {
      setIsInitialized(true);
      
      // Only redirect if user is on landing page and is authenticated
      if (accessToken && location.pathname === '/') {
        // Handle payment status for remote users first
        if (role === "User" && userFlow === "remote" && paymentStatus === "pending") {
          navigate("/paywall", { replace: true });
          return;
        }
        
        // Role-based redirect logic
        switch(role) {
          case "Admin":
            navigate("/admin-dashboard", { replace: true });
            break;
          case "Interviewer":
            navigate("/interviewer-dashboard", { replace: true });
            break;
          case "User":
          default:
            navigate("/user-dashboard", { replace: true });
            break;
        }
      }
    }, 100);
  }, [location.pathname, navigate]);

  // Show loading spinner while initializing
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--primary-color)]"></div>
      </div>
    );
  }

  return children;
};

export default AuthInitializer; 